import { Helpers } from './helpers'

export default class IntercomManager {
  static init = async () => {
    // no intercom on screen
    if (!window.Intercom) return

    const user = await Helpers.getAuthUser()

    // stop if no user
    if (!user) return

    const userName = `${user.first_name} ${user.last_name}`
    const truncatedName = userName.length > 17 ? `${userName.substring(0, 17)}...` : userName

    // add user details to Intercom
    window.Intercom('boot', {
      app_id: 'bt8vmdib',
      user_id: user.id,
      name: truncatedName, // Full name
      email: user.email, // Email address
      created_at: new Date() // Signup date as a Unix timestamp
    });
  }

  static update = async (params = undefined) => {
    await IntercomManager.init()

    // no intercom on screen
    if (!window.Intercom) return

    // get user ID
    const user = await Helpers.getAuthUser()

    const updateParams = {
      user_id: user ? user.id : null,
      ...params
    }

    // update so latest messages show up
    window.Intercom('update', updateParams)
  }

  static signOut = () => {
    // no intercom on screen
    if (!window.Intercom) return

    window.Intercom('shutdown')
  }
}
